var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0001 1.875C14.5093 1.875 1.875 14.5092 1.875 30C1.875 45.4908 14.5093 58.125 30.0001 58.125C45.4909 58.125 58.1251 45.4907 58.1251 30C58.1251 14.5093 45.4909 1.875 30.0001 1.875ZM30.0001 52.1886C17.779 52.1886 7.81137 42.2211 7.81137 30C7.81137 17.7789 17.7791 7.81137 30.0001 7.81137C42.2211 7.81137 52.1887 17.779 52.1887 30C52.1887 42.221 42.2213 52.1886 30.0001 52.1886ZM42.0074 20.7355C43.1848 21.913 43.1849 23.8395 42.0074 25.0168L27.9601 39.0641C27.1222 39.902 26.0455 40.2676 24.8706 40.1129C23.6957 39.9582 22.7502 39.3266 22.1577 38.3004L17.5127 30.2549C16.6801 28.8129 17.1788 26.952 18.6209 26.1193C20.0629 25.2868 21.9238 25.7854 22.7564 27.2275L25.8593 32.602L37.7258 20.7355C38.9032 19.5581 40.8298 19.5581 42.0073 20.7355H42.0074Z",
    fill: "url(#paint0_linear_11307_6405)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11307_6405",
    x1: 30.0001,
    y1: 58.125,
    x2: 30.0001,
    y2: 1.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA49C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6cd5506f2e84722509938c7ec63afc16.svg";
export { ForwardRef as ReactComponent };